import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { connect } from "react-redux";
import {
  addPlaylistV2,
  clonePlaylistV2,
  bulkUpdateRequest,
  playlistUpdateTagsRequest,
  confirmationRequest,
  fetchPlaylistsV2,
  filterPlaylistByTag,
  setPageTitle,
  bulkDeletePlaylist,
  bulkUpdatePlaylist,
  fetchTags,
  setPlaylistTags,
  addTag,
  addUserReport,
} from "../../actions";

import PropTypes from "prop-types";
import React, { Component } from "react";
import { Link } from "react-router-dom/es";
import "./styles.scss";
import "react-table-v6/react-table.css";
import selectTableHOC from "react-table/lib/hoc/selectTable";
import PropTypes from "prop-types";
import Table from "react-table";
import "react-table-v6/react-table.css";
import Dropdown, {
  DropdownContent,
  DropdownTrigger,
} from "react-simple-dropdown";
import { actions as notifActions } from "redux-notifications";
import { searchPlaylists, fetchPagedPlayistsV2 } from "signoxe/actions";
import { callOnEnter } from "signoxe/utils/eventHelpers";
const SelectTable = selectTableHOC(Table);

import { PLAYLISTS_RESOURCE, PLAYLISTS_RESOURCE_V2 } from "../../api/resources";
import {
  Page,
  PlaylistList,
  EventsPlaylistModal
} from "../../components";
import { EmptyMessage } from "signoxe/components/widgets";
import { CustomLoading } from "signoxe/components/widgets/Loading";

import DeviceAddSaveCancelWidget from "../../components/widgets/DeviceAddSaveCancelWidget";
import { searchStrFromRouterLocation } from "signoxe/utils/router";

import { SearchFilterBar} from "../../components/widgets";
import {
  getPlaylistsV2,
  getPlaylistPreloadStateV2,
  getFilteredPlaylistsV2,
  isFetchingPlaylistV2,
  getTagsAll,
  getProfile,
} from "../../selectors";
import { Box, Button } from '../../components';


const { notifSend } = notifActions;

class PlaylistsPage extends React.Component {
  static defaultProps = {
    keyField: "id",
  };

  static propTypes = {
    addUserReport: PropTypes.func.isRequired,
    groups: PropTypes.array.isRequired,
    searchPlaylists: PropTypes.func.isRequired,
    fetchTags: PropTypes.func.isRequired,
    addTag: PropTypes.func.isRequired,
    fetchPlaylistsV2: PropTypes.func.isRequired,
    filterPlaylistByTag: PropTypes.func.isRequired,
    addPlaylistV2: PropTypes.func.isRequired,
    setPlaylistTags: PropTypes.func.isRequired,
    bulkDeletePlaylist: PropTypes.func.isRequired,
    bulkUpdatePlaylist: PropTypes.func.isRequired,
    clonePlaylistV2: PropTypes.func.isRequired,
    setPageTitle: PropTypes.func.isRequired,
    bulkUpdateRequest: PropTypes.func.isRequired,
    playlistsV2: PropTypes.array.isRequired,
    profile: PropTypes.array.isRequired,
    tags: PropTypes.array.isRequired,
    keyField: PropTypes.string,
    searchString: PropTypes.string,
    history: PropTypes.object.isRequired,
    confirmationRequest: PropTypes.func.isRequired,
    isFetching: PropTypes.bool.isRequired,

  };

  constructor(props) {
    super(props);

    this.state = {
      error: null,
      isLoading: false,
      searchInput: "",
      filteredResults: [],
      selected: null,
      selectAll: false,
      selection: [],
      keys: [],
      toggleSearchBar: false,
      toggleCreateTag: false,
      toggleCreateEventPlaylist: false,
      editing: false,
      saveToggled: true,
      deleteToggled: false,
      inputedValue: "",
      showPopup: false,
      showMobileMenu: true,
      playlists: [],
      event_playlist_name: "",
      reportActivityStatus:
        this.props.profile &&
        this.props.profile.features &&
        this.props.profile.features.record_user_activity,
    };
  }

  escFunction(event) {
    if (event.key === "Escape") {
      this.setState({ selection: [] });
      this.setState({ showPopup: false });
    }
  }
  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }
  handleTagAdd = (playlist, tag) =>
    this.props.setPlaylistTags(playlist.id, playlist.tags.concat(tag));

  handleAddTag = (name) => this.props.addTag({ name });

  handleAddPlaylist = (name) =>
    this.props.addPlaylistV2({ name, auto_add_feeds: false, maintags: [] });
  
  handleAddEventPlaylist = (name, location, event_type) => {
    this.props.addPlaylistV2({ name, location, event_type, auto_add_feeds: false, maintags: [], is_event:true}); 
  }
  handleAddPlaylistWithFeeds = (name) => this.props.addPlaylist({ name });

  handleBulkDeletePlaylists = (playlist) =>
    this.props.bulkDeletePlaylist(playlist);

  handleBulkUpdatePlaylists = (playlist) =>
    this.props.bulkUpdatePlaylist(playlist);

  handleClonePlaylist = (playlist) => this.props.clonePlaylistV2(playlist);

  handleUpdatePlaylistTags = (playlist) => {
    {playlist && playlist.listags &&
    this.props.playlistUpdateTagsRequest(
      "Select Tags to Update Playlist",
      "DELETE",
      PLAYLISTS_RESOURCE_V2,
      playlist,
      playlist.listags
    );}
  };

  handleDeletePlaylist = (playlist) => {
    const { profile } = this.props;
    if (this.state.reportActivityStatus) {
      this.props.addUserReport({
        user: profile.id,
        action_type: "Delete",
        activity: `deleted (or attempt to delete) playlist - ${playlist.name}`,
      });
    }
    this.props.confirmationRequest(
      "Deleting Playlist",
      `Deleting the playlist "${playlist.name}" is permanent and cannot be undone.`,
      "DELETE",
      PLAYLISTS_RESOURCE_V2,
      playlist.id
    );
  };

  handleSwitchSaveAll = () => {
    this.setState({ deleteToggled: false });
    this.setState({ saveToggled: true });
  };

  
  handleSwitchDeleteSelected = () => {
    this.setState({ saveToggled: false });
    this.setState({ deleteToggled: true });
  };

  componentDidMount() {
    this.props.fetchPlaylistsV2()
    this.setState({ playlists: this.props.groups });
    this.props.setPageTitle("Playlists");
    this.props.searchPlaylists(""); // Clear any existing search query
    this.fetchNextPlaylist = setInterval(() => {
      if(this.props.next && this.props.next.length && !this.props.isFetching ){
        this.props.fetchPagedPlayistsV2(this.props.next);
      }
    }, 5000); // 60000 milliseconds = 1 minute
  }

  componentWillUnmount() {
    clearInterval(this.fetchNextPlaylist);
  }

  handleFilter = (filterOn, filter) => {
    if (filterOn === "TAGS") {
      this.props.filterPlaylistByTag(filter);
    }
  };

  handleSearch = (searchValue) => {
    this.props.history.replace({
      search: `?search=${searchValue}`,
    });
  };

  toggleSelection = (key, shift, row) => {
    // start off with the existing state
    let selection = [...this.state.selection];
    const keyIndex = selection.indexOf(key);

    // check to see if the key exists
    if (keyIndex >= 0) {
      // it does exist so we will remove it using destructing
      selection = [
        ...selection.slice(0, keyIndex),
        ...selection.slice(keyIndex + 1),
      ];
    } else {
      // it does not exist so add it
      selection.push(key);
    }
    // update the state
    this.setState({ selection });
  };

  toggleAll = () => {
    const { keyField } = this.props;
    const selectAll = !this.state.selectAll;
    const selection = [];

    if (selectAll) {
      // we need to get at the internals of ReactTable
      const wrappedInstance = this.checkboxTable.getWrappedInstance();
      // the 'sortedData' property contains the currently accessible records based on the filter and sort
      const currentRecords = wrappedInstance.getResolvedState().sortedData;
      // we just push all the IDs onto the selection array
      currentRecords.forEach((item) => {
        selection.push(`select-${item._original[keyField]}`);
      });
    }
    this.setState({ selectAll, selection });
  };

  resetViews = () => {
    this.setState({ selection: [] });
    this.setState({ showPopup: false });
  };

  saveEdits = () => {
    var array = [];
    for (const name in this.state.keys) {
      array.push(this.state.keys[name]["original"]);
    }

    this.props.bulkUpdateRequest(
      "Bulk Playlist Update",
      `Confirm Updating of "${array.length}" playlist(s).`,
      "PATCH",
      PLAYLISTS_RESOURCE_V2,
      array.length,
      array
    );
  };
  quickSave = () => {
    var array = [];
    for (const name in this.state.keys) {
      array.push(this.state.keys[name]["original"]);
    }
    this.handleBulkUpdatePlaylists(array);
  };

  deleteAllSelected = () => {
    var arrayStr = this.state.selection.map(function (x) {
      return x.replace("select-", "");
    });

    var arrToNum = arrayStr.map((str) => {
      return Number(str);
    });
    this.setState({ isLoading: true });

    let new_arrray = this.props.groups;
    var newr = new_arrray.filter((e) => arrToNum.find((num) => e.id === num));
    var playlists_names = newr && newr.map((e) => e.name).join(", ");
    const {profile} = this.props
    if (this.props.profile &&
      this.props.profile.features &&
      this.props.profile.features.record_user_activity) {
      this.props.addUserReport({
        user: profile.id,
        action_type: "Delete",
        activity: `Bulk deletion  (or attempt to delete) these playlists - ${playlists_names}}`,
      });
    }

    // this.handleBulkDeletePlaylists(arrToNum)

    this.props.bulkUpdateRequest(
      "Bulk Playlist Delete",
      `Confirm deleting of "${arrToNum.length}" playlist(s), cannot be undone.`,
      "DELETE",
      PLAYLISTS_RESOURCE,
      arrToNum.length,
      arrToNum
    );
    this.setState({ isLoading: false });
    this.setState({ showPopup: false });
    this.setState({ selection: [] });
  };
  
  onToggleCreatePlaylist = () => {
    this.setState({ toggleCreateTag: false });
    this.setState({ toggleSearchBar: true });
    this.setState({ showMobileMenu: false });
  };

  onTogggleCreateEventPlaylist = () => {
    this.setState({toggleCreateEventPlaylist : !this.state.toggleCreateEventPlaylist });
  };

  onSaveEventPlaylist = () => {
    this.handleAddEventPlaylist(this.state.event_playlist_name)
    this.setState({toggleCreateEventPlaylist : !this.state.toggleCreateEventPlaylist });
  };

  onToggleCreateTags = () => {
    this.setState({ toggleCreateTag: true });
    this.setState({ toggleSearchBar: true });
    this.setState({ showMobileMenu: false });
  };

  onToggleBack = () => {
    this.setState({ toggleCreateTag: false });
    this.setState({ toggleSearchBar: false });
    this.setState({ showMobileMenu: true });
  };

  
  onToggleEdit = () => {
    this.setState({ editing: !this.state.editing });
    this.setState({ selection: [] });
    this.setState({ showPopup: !this.state.showPopup });
  };
  isSelected = (key) => {
    return this.state.selection.includes(`select-${key}`);
  };

  rowFn = (state, rowInfo, column, instance) => {
    const { selection } = this.state;

    return {
      onClick: (e, handleOriginal) => {
        if (handleOriginal) {
          handleOriginal();
        }
      },
      style: {
        background:
          rowInfo &&
          selection.includes(`select-${rowInfo.original.id}`) &&
          "#ccd1d1 ",
      },
    };
  };

  listPlaylistTags = (playlist) => {
    let newOrder = "";
    playlist &&
      playlist.listags.forEach((item, index) => {
        if (index === playlist.listags.length - 2) {
          newOrder += item.name + ",";
        } else if (index === playlist.listags.length - 1) {
          newOrder += item.name + ".";
        } else {
          newOrder += item.name + ", ";
        }
      });
    return (
      <span
        title="Add Tags"
        className="flex hide-for-mobile"
        onClick={() => {
          this.handleUpdatePlaylistTags(playlist);
        }}
      >
        <i className="fas fa-plus-circle mr--sm text-primary"></i>
        <small className="is-cursor">{newOrder}</small>
      </span>
    );
  };

  renderEditable = (cellInfo) => {
    return (
      <div>
        {this.state.editing ? (
          <input
            style={{ backgroundColor: "transparent" }}
            type="text"
            value={this.props.groups[cellInfo.index][cellInfo.column.id]}
            onChange={(e) => {
              const data = [...this.props.groups];
              let editedData = [...this.state.keys];
              data[cellInfo.index][cellInfo.column.id] = e.target.value;
              editedData.push(cellInfo);
              this.setState({ keys: editedData });
              this.quickSave;
            }}
            onBlur={(e) => {
              this.quickSave;
            }}
            onKeyDown={callOnEnter(this.quickSave)}
          />
        ) : (
          <Link
            to={`/playlists/${cellInfo.original.id}`}
            className="is-cursor text-dark"
            suppressContentEditableWarning
            dangerouslySetInnerHTML={{
              __html: this.props.groups[cellInfo.index][cellInfo.column.id],
            }}
          />
        )}
      </div>
    );
  };

  render() {
    console.log("testing playlistsv2", this.props.groups)
    const profile = this.props.profile
    const allowed_pages = profile && this.props.profile.allowed_pages
    const isNotAllowed = profile && allowed_pages && this.props.profile.allowed_pages.playlist_page
    const {
      isLoading,
      editing,
      toggleCreateTag,
      toggleSearchBar,
      showMobileMenu,
      selectAll,
      toggleCreateEventPlaylist,
    } = this.state;

  
    return (

     <Page isNotAllowed={isNotAllowed}>
     {this.state.selection.length != 0 && (
       <div id="note">
         <div>
           <h6>
             {this.state.selection && this.state.selection.length}
             {this.state.selection.length > 1
               ? " Items Selected"
               : " Item Selected"}
           </h6>
         </div>
         <div className="btns">
           <button className="btn1" onClick={this.resetViews}>
             {" "}
             <i className="fas fa-eye-slash"></i> RESET VIEWS
           </button>
           <button className="btn2" onClick={this.deleteAllSelected}>
             {" "}
             <i className="fas fa-trash"></i> DELETE
           </button>
         </div>
       </div>
     )}
       {toggleCreateEventPlaylist ? (
       <EventsPlaylistModal
       handleAddEventPlaylist={this.handleAddEventPlaylist}
       onTogggleCreateEventPlaylist={this.onTogggleCreateEventPlaylist}
       />
     ) : null}

     <div className="flex flex-dc">
       <div class="flex flex-dc">
         <div className="margin-bottom">
           <div class=" searchbar flex flex-jc-sb mb-3 ">
             {toggleSearchBar === false ? (
               <SearchFilterBar
                 className="input-group-2"
                 placeholder="Search Playlist/Tags"
                 queryString={this.props.searchString}
                 onQueryChange={this.handleSearch}
                 onFilterChange={this.handleFilter}
               />
             ) : (
               <div className="">
                 {toggleCreateTag === true ? (
                   <DeviceAddSaveCancelWidget
                     addLabel="Add Playlist Tag"
                     onToggle={this.onToggleBack}
                     onSave={this.handleAddTag}
                   />
                 ) : (
                   <DeviceAddSaveCancelWidget
                     addLabel="Add Playlist"
                     onToggle={this.onToggleBack}
                     onSave={this.handleAddPlaylist}
                   />
                 )}
               </div>
             )}

             {showMobileMenu === true && (
               <div className="hide-for-desktop">
                 <Dropdown>
                   <DropdownTrigger>
                     <button type="button" className="button">
                       <span
                         style={{ marginRight: "5px", fontSize: "0.7rem" }}
                       >
                         Actions
                       </span>
                       <span
                         title="actions"
                         className="icon fa fa-caret-down"
                         style={{ fontSize: "1rem", color: "#fff" }}
                       ></span>
                     </button>
                   </DropdownTrigger>
                   <DropdownContent className="user-menu actions-menu card depth-1">
                     <li onClick={this.onToggleCreatePlaylist}>
                       Create a Playlist
                     </li>
                     {/* <li onClick={this.onTogggleCreateEventPlaylist}>
                     Create Event Playlist
                     </li> */}
                     <li onClick={this.onToggleCreateTags}>Create Tag</li>
                     <li onClick={this.onToggleEdit}>
                       <i
                         className={
                           editing
                             ? "fas fa-toggle-on mr-1"
                             : "fas fa-toggle-off mr-1"
                         }
                       ></i>
                       Edit Mode
                     </li>
                   </DropdownContent>
                 </Dropdown>
               </div>
             )}


                 
             
             <div class="flex flex-ai-c hide-for-mobile">


                 <Dropdown>
                   <DropdownTrigger>
                     <button type="button" className="button">
                       <span
                         style={{ marginRight: "5px", fontSize: "0.9rem" }}
                       >
                         Create Playlist
                       </span>
                       <span
                         title="actions"
                         className="icon fa fa-caret-down"
                         style={{ fontSize: "1rem", color: "#fff" }}
                       ></span>
                     </button>
                   </DropdownTrigger>
                   <DropdownContent className="user-menu actions-menu card depth-1">
                    {!toggleCreateEventPlaylist && <Fragment>
                     <li onClick={this.onToggleCreatePlaylist}>
                     Create Playlist
                     </li>
                     {/* <li onClick={this.onTogggleCreateEventPlaylist}>
                     Create Event Playlist
                     </li> */}
                     </Fragment>}
             
                   </DropdownContent>
                 </Dropdown>
               <button class="button ctb " onClick={this.onToggleCreateTags}>
                 <i className="fas fa-plus mr-1"></i>
                 Create Tag
               </button>
               {this.props.playlists.length != 0 && (
                 <button
                   className={editing ? "button btn-bg" : "button"}
                   onClick={this.onToggleEdit}
                 >
                   <i
                     class={
                       editing
                         ? "fas fa-toggle-on mr-1"
                         : "fas fa-toggle-off mr-1"
                     }
                   ></i>
                   Edit Mode{" "}
                 </button>
               )}
             </div>
           </div>
         </div>
         {/* <Box justifyContent="center">
        {
          this.props.next && this.props.next.length ?
          (
            <Button className='load-more' onClick={!this.props.isFetching ? ()=>{
              this.props.fetchPagedPlayists(this.props.next)
            }: null}>
              Load more Playlists
            </Button>
          ): ''
        }
        </Box> */}

      
           {!this.props.isFetching  && this.props.groups.length === 0 ?  
             <EmptyMessage text="Your playlist is empty. Please Add one!" />
             : 
             <PlaylistList
               playlists={this.props.groups}
               isLoading={isLoading}
               selectAll={selectAll}
               handleToggleAll={this.toggleAll}
               checkedIsSelected={this.isSelected}
               tableProps={this.rowFn}
               onDelete={this.handleDeletePlaylist}
               onClone={this.handleClonePlaylist}
               refKey={(r) => (this.checkboxTable = r)}
               toggleSelection={this.toggleSelection}
               editing={editing}
               handleDeletePlaylist={this.handleDeletePlaylist}
               renderEditable={this.renderEditable}
               listPlaylistTags={this.listPlaylistTags}
               handleClonePlaylist={this.handleClonePlaylist}
               onToggleEdit={this.onToggleEdit}
             />

             }

            {this.props.isFetching && this.props.groups && this.props.groups.length > 0 &&  this.props.next &&
            this.props.next.length &&
            <CustomLoading
            text="Still Loading Playlists"
            />
            }
           </div>
         
     </div>
    
    </Page> 


   
    );
  }
  }


export default connect(
  (state, props) => {
    const searchString = searchStrFromRouterLocation(props.location);
    return {
      searchString,
      groups: getFilteredPlaylistsV2(state, searchString),
      tags: getTagsAll(state),
      playlists: getPlaylistsV2(state),
      next: getPlaylistPreloadStateV2(state),
      isFetching: isFetchingPlaylistV2(state),
      profile: getProfile(state),

    };
  },
  {
    fetchPlaylistsV2,
    fetchPagedPlayistsV2,
    addPlaylistV2,
    clonePlaylistV2,
    setPageTitle,
    playlistUpdateTagsRequest,
    bulkUpdateRequest,
    bulkDeletePlaylist,
    bulkUpdatePlaylist,
    filterPlaylistByTag,
    addTag,
    setPlaylistTags,
    confirmationRequest,
    fetchTags,
    searchPlaylists,
    addUserReport,
  }
)(PlaylistsPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/PlaylistsPage/index.js